export enum UIConfig {
    available_subjects_filter_group = 'available_subjects_filter_group',
}